import 'ol/ol.css';
import { getMap } from './MapView';
import {
  geodkSelectedFeatures,
  geodkWFS,
  vejmidteWMS,
  kommuneWMS,
  createGeodkWFSHighlight,
  geodkVectorSelected,
  ortho,
  forvaltning,
  wmts,
  matrikel,
  husnr,
  createAdressepunkterHighlight,
  creategeodkVectorSelectedHighlight,
} from './Layers';
import { getAdresseringFromVejkodeObjekt } from '@/util';
import { isLayerVisible } from './util';

export function setupMap (store, targetElement) {
  geodkWFS.token = store.state.user.token;
  let layers = [ wmts, ortho, forvaltning, matrikel, husnr, geodkWFS, vejmidteWMS, kommuneWMS, geodkVectorSelected ];
  let map = getMap(targetElement, layers, store.state.center, store.state.zoom);
  let geodkWFSHighlight = createGeodkWFSHighlight(map);
  layers.push(geodkWFSHighlight);
  let adressepunkterHighlight = createAdressepunkterHighlight(map);
  layers.push(adressepunkterHighlight);
  let geodkVectorSelectedHighlight = creategeodkVectorSelectedHighlight(map);
  layers.push(geodkVectorSelectedHighlight);

  layers.forEach(function (layer) {
    if (layer === geodkWFS) {
      layer.setZIndex(1);
    } else if (layer === geodkVectorSelected) {
      layer.setZIndex(2);
    } else if (layer === geodkVectorSelectedHighlight) {
      layer.setZIndex(3);
    } else {
      layer.setZIndex(0);
    }
  });

  let onClick = e => { // toggle GeoDK feature
    const hasFeatureAtPixel = map.hasFeatureAtPixel(e.pixel, {
      layerFilter: layer => layer.get('name') === 'geodkVectorSelected',
    });
    if (hasFeatureAtPixel) {
      map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
        if (layer === geodkVectorSelected) {
          store.commit('removeGeoDkObjekt', feature);
        }
      });
    } else {
      if (map.getView().getResolution() < 1.51) {
        store.dispatch('getGeoDkObjektByCoordinate', e.coordinate);
      }
    }
    geodkVectorSelectedHighlight.getSource().clear();
  };
  map.on('click', onClick);

  let onPointerMove = e => {
    geodkWFSHighlight.getSource().clear();
    adressepunkterHighlight.getSource().clear();
    geodkVectorSelectedHighlight.getSource().clear();
    map.getViewport().style.cursor = 'pointer';
    if (
      map.hasFeatureAtPixel(e.pixel, {
        layerFilter: layer => layer.get('name') === 'geodkWFS',
      })
    ) {
      map.getViewport().style.cursor = 'pointer';
      map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
        if (layer === geodkWFS) {
          const vejkode = feature.get('vejkode');
          const kommunekode = feature.get('kommunekode');
          const vejmidtetype = feature.get('vejmidtetype');
          const vejkategori = feature.get('vejkategori').split('-')[0]; // TODO: vejkategori finnes kun på geodk objekt
          if (vejkode) {
            store.commit('updatePopup', {
              loading: true,
              // visible: true,
              x: e.pixel[0],
              y: e.pixel[1],
              geoDkId: parseInt(feature.getId().split('.')[1]),
              vejkode,
              vejmidteType: `${vejmidtetype}/${vejkategori}`,
            });
            store.dispatch('getVejkodeAdressering', { kommunekode, vejkode })
              .then(vejkodeMedAdressering => {
                const adressering = getAdresseringFromVejkodeObjekt(vejkodeMedAdressering);
                store.commit('updatePopup', {
                  visible: true,
                  loading: false,
                  vejnavn: adressering.navn,
                  postnummer: adressering.postnr,
                });
              })
              .catch(() => {
                const vejkodeUkendtAdressering = {
                  kode: vejkode,
                  navn: 'Ukendt vej',
                  ukendt: true,
                };
                store.commit('addFetchedVejkoder', vejkodeUkendtAdressering);
                store.commit('updatePopup', {
                  visible: true,
                  loading: false,
                  vejnavn: 'Ukendt vej',
                });
              });

            layer.getSource().forEachFeature(f => {
              if (f.get('vejkode') === vejkode && f.get('kommunekode') === kommunekode) {
                geodkWFSHighlight.getSource().addFeature(f);
              }
            });
            // console.log('Antal features Geodk WFS: ' + layer.getSource().getFeatures().length);
            if (isLayerVisible(map, 'Husnummer')) {
              store.dispatch('getVejkodeAdressePunkter', { vejkode, kommunekode })
                .then(adresse => {
                  adressepunkterHighlight.getSource().clear();
                  adressepunkterHighlight.getSource().addFeatures(adresse.adressepunkter);
                  adressepunkterHighlight.getSource().addFeatures(adresse.vejpunktlinje);
                })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            geodkWFSHighlight.getSource().addFeature(feature);
            store.commit('updatePopup', {
              visible: true,
              loading: false,
              x: e.pixel[0],
              y: e.pixel[1],
              geoDkId: parseInt(feature.getId().split('.')[1]),
              vejkode: 'Ingen',
              vejnavn: '',
              postnummer: '',
              vejmidteType: `${vejmidtetype}/${vejkategori}`,
            });
          }
        }
        if (layer === geodkVectorSelected) {
          store.commit('highlightSelectedGeodk', {
            geoDkId: feature.get('geoDkId'),
            scrollTo: true,
          });
        }
      });
    } else {
      map.getViewport().style.cursor = '';
      store.commit('updatePopup', {
        visible: false,
      });
      store.commit('highlightSelectedGeodk', {});
    }
  };
  map.on('pointermove', onPointerMove);

  // opdater state når kort flyttes:
  map.on('moveend', event => {
    store.commit('setCenter', event.map.getView().getCenter());
    store.commit('setZoom', event.map.getView().getZoom());
  });

  // opdater kort når state ændres:
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setZoom') {
      const view = map.getView();
      view.setZoom(mutation.payload);
    }
    if (mutation.type === 'setCenter') {
      const view = map.getView();
      view.setCenter(mutation.payload);
    }
    if (mutation.type === 'addGeoDkObjekt') {
      geodkSelectedFeatures.push(mutation.payload);
    }
    if (mutation.type === 'removeGeoDkObjekt') {
      geodkSelectedFeatures.remove(mutation.payload);
    }
    if (mutation.type === 'removeAllGeoDkObjekter') {
      geodkSelectedFeatures.clear();
    }
    if (mutation.type === 'toggleVisibleLayer') {
      layers.forEach(function (layer) {
        layer.getType() === 'TILE' && layer.getLayerState().visible
          ? layer.setVisible(false)
          : layer.setVisible(true);
      });
    }
    if (mutation.type === 'highlightSelectedGeodk') {
      geodkVectorSelectedHighlight.getSource().clear();
      const { geoDkId } = mutation.payload;
      geodkVectorSelected.getSource().forEachFeature(f => {
        if (f.get('geoDkId') === geoDkId) {
          geodkVectorSelectedHighlight.getSource().addFeature(f);
        }
      });
    }
  });
  return map;
}
